<template>
  <basic-container>
    <avue-crud
      :data="data"
      :option="option"
      :table-loading="tableLoading"
      @row-save="handleRowSave"
      @row-del="handleDel"
      @row-update="handleRowUpdate"
      :editBtn="false"
      :delBtn="false"
      @on-load="getDataList"
      @refresh-change="getDataList"
    >
    </avue-crud>
  </basic-container>
</template>
<style scoped></style>
<script>
import {
  getFormById,
  getFormDataList,
  addFormData,
  updateFormData,
  deleteFormData,
} from '@/api/form';
export default {
  data() {
    return {
      data: [],
      option: {},
      formData: {},
      tableLoading: false,
    };
  },
  mounted() {
    this.getDataList();
  },
  activated() {
    this.getDataList();
  },
  methods: {
    getDataList() {
      let formId = this.$route.query.id;
      let self = this;
      if (formId) {
        getFormById(formId).then((res) => {
          console.log(res.data);
          self.option = this.getCrudOption(JSON.parse(res.data.detail));
          self.formData = res.data;
          console.log(self.option);
          // self.option.delBtn = false;
          // self.option.editBtn = false;
          // self.option.addBtn = false;
          getFormDataList(formId).then((res) => {
            console.log(res.data);
            self.data = self.getTableDataList(res.data.data);
          });
        });
      } else {
        //   localStorage.removeItem('avue-form-history');
      }
    },
    getTableDataList(list) {
      let arr = this.deepClone(list);
      let listArray = [];
      arr.forEach((e, i) => {
        // e.dataDetail.id = e.id;
        // let tmp = JSON.parse(e.dataDetail);

        listArray.push({ ...JSON.parse(e.dataDetail), id: e.id });
      });
      return listArray;
    },
    getCrudOption(obj) {
      let option_objs = this.deepClone(obj);
      option_objs.column.push({
        type: 'input',
        label: 'id',
        disabled: true,
        span: 24,
        display: false,
        prop: 'id',
      });
      if (option_objs.group) {
        option_objs.group.forEach((e, i) => {
          if (e.column.length > 0) {
            e.column.forEach((el, index) => {
              option_objs.column.push(el);
            });
          }
        });
      }
      return option_objs;
    },
    handleRowSave(row, done, loading) {
      this.tableLoading = true;
      let self = this;
      console.log(row);
      addFormData({
        formCode: self.formData.formCode,
        formName: self.formData.formName,
        detail: self.formData.detail,
        formId: self.formData.id,
        dataDetail: JSON.stringify(row),
      }).then((res) => {
        console.log(res);
        self.getDataList();
        this.tableLoading = false;
      });
      done();
    },
    handleDel(row, index) {
      this.tableLoading = true;
      let self = this;
      console.log(row);
      deleteFormData({
        id: row.id,
        // dataDetail:JSON.stringify(row)
      }).then((res) => {
        console.log(res);
        this.$message.success('删除成功!');
        self.getDataList();
        this.tableLoading = false;
      });
    },
    handleRowUpdate(row, index, done, loading) {
      this.tableLoading = true;
      let self = this;
      console.log(row);
      updateFormData({
        id: row.id,
        dataDetail: JSON.stringify(row),
      }).then((res) => {
        console.log(res);
        self.getDataList();
        this.tableLoading = false;
      });
      done();
    },
  },
};
</script>
